import React from "react";
import styled from "styled-components";
import translate from "../../providers/i18n/translate";
import { ThemeContext } from "../../providers/theme";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { Table, SearchInput } from "../../components/tables/table";
import axios from "axios";
import { API_URL } from "../../config";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../store/action-creators";
import { alertConstants } from "../../store/reducers/messageBar/alertConstants";

/* Styled components */
const Root = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 0 50px;
  grid-row: 1/3;
`;

const Title = styled.h2`
  position: relative;
  display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  justify-content: flex-start;
  text-transform: uppercase;
  color: ${(props) => (props.color ? props.color : "#000")};
  border-bottom: 1px solid
    ${(props) => (props.borderColor ? props.borderColor : "red")};
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  height: calc(100% - 50px);
  padding: 25px 0 0 0;
`;

const SignaturesList = React.forwardRef(({loadSignature}, ref) => {
  const theme = React.useContext(ThemeContext);

  const tableRef = ref;

  const navigate = useNavigate();

  const intl = useIntl();

  const dispatch = useDispatch();

  const { alertMessage } = bindActionCreators(actionCreators, dispatch);

  const [search, setSearch] = React.useState("");

  const [editData, setEditData] = React.useState(null);

  const columnsTable = [
    { title: "ID", field: "id", width: "8%", order: false, hidden: false },
    {
      title: translate("name"),
      field: "name",
      width: "80%",
      order: false,
      hidden: false,
    },
    {
        title: translate("metadata"),
        field: "name",
        width: "10%",
        order: false,
        hidden: true,
      },
    {
      title: translate("actions"),
      actions: true,
      width: "auto",
      hidden: false,
    },
  ];

  const onSearchChange = (value) => {
    setSearch(value);
  };

  const handleSearch = () => {
    tableRef.current.clean();
  };

  const handleViewItem = (data) => {
    loadSignature(data);
  };

  const handleDeleteItem = (data) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm(intl.formatMessage({ id: "confirm delete" }))) {
      axios
        .delete(`${API_URL}/signatures/${data.id}`)
        .then((result) => {
          setTimeout(() => {
            tableRef.current.clean();
            alertMessage(
              intl.formatMessage({ id: "signature deleted" }),
              alertConstants.INFO
            );
          }, 500);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const actionsTable = {
    view: {
      icon: theme.icons.view,
      tooltip: "Cargar",
      onClick: handleViewItem,
      color: theme.palette.principal,
      hoverColor: theme.palette.accent,
      hidden: false,
    },
    delete: {
      icon: theme.icons.delete,
      tooltip: "Eliminar",
      onClick: handleDeleteItem,
      color: theme.palette.principal,
      hoverColor: theme.palette.accent,
      hidden: false,
    },
  };

  return (
    <Root>
      <Title color={theme.palette.accent} borderColor={theme.palette.details}>
        {translate("signatures")}
      </Title>
      <Content>
        <Table
          ref={tableRef}
          columns={columnsTable}
          actionsTable={actionsTable}
          viewTable="list"
          disablePlain
          data={(query) =>
            new Promise((resolve, reject) => {
              axios
                .get(`${API_URL}/signatures`, {
                  params: {
                    page: query.page - 1,
                    limit: query.pageSize,
                    search: search,
                    order: query.order,
                  },
                })
                .then((result) => {
                  resolve(result.data);
                })
                .catch((err) => {
                  console.log(err);
                });
            })
          }
        >
          <SearchInput
            search={search}
            onChange={onSearchChange}
            onSearch={handleSearch}
          />
        </Table>
      </Content>
    </Root>
  );
});

export default SignaturesList;
